import * as Sentry from "@sentry/browser";

export const BulkDownload = {
  mounted() {
    this.handleEvent("bulk_download", async ({ links }) => {
      for (const { link, name } of links) {
        console.log("Downloading ", link);

        try {
          const response = await fetch(link);

          if (!response.ok) {
            throw new Error(response.statusText || "Unknown error");
          }

          // Convert response to a Blob
          const blob = await response.blob();

          // Create an object URL for the Blob
          const objectUrl = URL.createObjectURL(blob);

          // Create a temporary anchor tag and trigger download
          const a = document.createElement("a");
          a.href = objectUrl;

          // Extract filename from URL or use a default name
          a.download = name;

          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);

          // Revoke the object URL to free up memory
          URL.revokeObjectURL(objectUrl);
        } catch (error) {
          const context = { name, link };

          Sentry.captureException(error, { data: context });

          console.error("Failed to download file:", {
            ...context,
            reason: error.message,
          });

          this.pushEvent("download_failed", {
            message: "Failed to download file",
            reason: error.message,
          });
        }
      }
    });
  },
};
